import {
  signInWithPopup,
  signOut,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged
} from 'firebase/auth';
import { auth, googleProvider } from './config';
import { saveToLocalStorage } from '../utils/localStorage';

// Super Admin Emails
const SUPER_ADMIN_EMAILS = [
  'fayedruet@gmail.com',
  'mdashrafulislamashh@gmail.com'
];

// Check if email is super admin
const isSuperAdmin = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return SUPER_ADMIN_EMAILS.some(adminEmail => adminEmail.toLowerCase() === normalizedEmail);
};

// Google Sign In
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;

    // Check if super admin and set role
    const role = isSuperAdmin(user.email) ? 'admin' : undefined;

    // Save user session to localStorage
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      loginMethod: 'google',
      ...(role && { role })
    };

    saveToLocalStorage('currentUser', userData);
    return { success: true, user: userData };
  } catch (error) {
    console.error('Google Sign In Error:', error);
    return { success: false, error: error.message };
  }
};

// Email/Password Sign In
export const signInWithEmail = async (email, password) => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    const user = result.user;

    // Check if super admin and set role
    const role = isSuperAdmin(user.email) ? 'admin' : undefined;

    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      loginMethod: 'email',
      ...(role && { role })
    };

    saveToLocalStorage('currentUser', userData);
    return { success: true, user: userData };
  } catch (error) {
    console.error('Email Sign In Error:', error);
    return { success: false, error: error.message };
  }
};

// Email/Password Sign Up
export const signUpWithEmail = async (email, password, displayName) => {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    const user = result.user;

    // Check if super admin and set role
    const role = isSuperAdmin(user.email) ? 'admin' : undefined;

    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: displayName || user.email,
      photoURL: user.photoURL,
      loginMethod: 'email',
      ...(role && { role })
    };

    saveToLocalStorage('currentUser', userData);
    return { success: true, user: userData };
  } catch (error) {
    console.error('Email Sign Up Error:', error);
    return { success: false, error: error.message };
  }
};

// Sign Out
export const logOut = async () => {
  try {
    await signOut(auth);
    localStorage.removeItem('currentUser');
    return { success: true };
  } catch (error) {
    console.error('Sign Out Error:', error);
    return { success: false, error: error.message };
  }
};

// Auth State Observer
export const observeAuthState = (callback) => {
  return onAuthStateChanged(auth, (user) => {
    if (user) {
      const userData = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL
      };
      callback(userData);
    } else {
      callback(null);
    }
  });
};
